import { GigType } from "model/Gig";

export function getScheduleShiftTypeIconName(
  gigType?: GigType,
): "v2/globe" | "v2/shift" | "v2/team" | undefined {
  if (gigType === GigType.PUBLIC) {
    return "v2/globe";
  }

  if (gigType === GigType.WORKPOOL || gigType === GigType.WORKGROUP) {
    return "v2/team";
  }

  if (
    gigType !== undefined &&
    gigType !== GigType.SOLO &&
    gigType !== GigType.AUTOGENERATED
  ) {
    return "v2/shift";
  }

  return undefined;
}
